import React, { memo } from 'react';

import PropTypes from 'prop-types';
import { map, range } from 'lodash';
import Skeleton from '@mui/material/Skeleton';

const TableLoading = ({ repeat, ...rest }) =>
  map(range(repeat), (item) => <Skeleton key={item} {...rest} />);

TableLoading.propTypes = {
  repeat: PropTypes.number.isRequired,
};

export default memo(TableLoading);
